import styled from '@emotion/styled';
import { Button as _Button, Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { CreativeFormat, SingleAssignmentFragment } from '../../../graphql/generated/graphql_offer';
import { CreationByOptimizerId } from '../../../service/persistent/CreationSetWebApi';

type Props = {
  creativeFormat: Pick<CreativeFormat, 'id' | 'resizeBaseId'>;
  creation: CreationByOptimizerId | undefined;
  creationSetId: string;
  assignment: SingleAssignmentFragment;
  className?: string;
};

const CreationDetailLink: FC<Props> = ({ creativeFormat, creation, creationSetId, assignment, className }) => {
  // 新規投稿
  if (!creation) {
    let newLabel = null;
    if (
      assignment.status == 'CANDIDATED' &&
      assignment.candidatedStatus == 'APPLYING' &&
      !creativeFormat.resizeBaseId
    ) {
      newLabel = 'creation_state.proposal.link_label'; // 提案の新規投稿
    } else if (assignment.status == 'ASSIGNED') {
      newLabel = 'creation_state.submitting.link_label'; // アサイン後の新規投稿
    }
    if (newLabel != null) {
      return (
        <div className={className}>
          <Button
            variant="contained"
            size="small"
            color="primary"
            href={`/creation_sets/${creationSetId}/creations/a/${assignment.id}/cf/${creativeFormat.id}/new`}
            target="_blank"
          >
            <Typography color="inherit" align="center">
              <FormattedMessage id={newLabel} />
            </Typography>
          </Button>
        </div>
      );
    } else {
      return null;
    }
  }

  return (
    <div className={className}>
      <Button variant="contained" size="small" color="primary" href={`/creations/${creation.id}`} target="_blank">
        <Typography color="inherit" align="center">
          <FormattedMessage id={`creation_state.${creation.state}.link_label`} />
        </Typography>
      </Button>
    </div>
  );
};

const Button = (styled(_Button)({
  minWidth: 100,
  height: '100%',
  maxHeight: '32px',
  '> span > p.MuiTypography-body2': {
    lineHeight: 1,
  },
}) as unknown) as typeof _Button;

export default CreationDetailLink;
